<script>
    import List from './shared/list.svelte';
    import user from '../../state/user';
    import recordings from '../../state/recordings';

    let items = [];
    $: items = $recordings;
    $: onUserChange($user);

    // Reload on user change
    function onUserChange() {
        recordings.get();
    }

    // On init
    recordings.get();
</script>

<List {items} />
